import { type FlowRunType } from './flowRun.js';

interface BaseExecuteFlowQueryParams {
  practiceId?: string;
  entityType?: string;
  entityId?: string;
  blockMocks?: Record<string, unknown>;
  type?: FlowRunType;
}
export interface ExecuteFlowQueryParams extends BaseExecuteFlowQueryParams {
  flowId: string;
}

export interface ExecuteBulkQueryItem extends BaseExecuteFlowQueryParams {
  flowId?: string;
  flowDefinitionId?: string;
}

export interface ExecuteBulkQueryParams {
  flowRuns: ExecuteBulkQueryItem[];
  runGroupName: string;
  organizationId: string;
  type?: FlowRunType;
  concurrentLimit?: number;
  useExperimentalTaskQueue?: boolean;
}

export interface ExecuteBulkResponse {
  groupId: string;
  flowRunIds: string[];
  errorRows: ExecuteBulkError[];
}

interface ExecuteBulkError extends ExecuteBulkQueryItem {
  error: string;
  index: number;
}

export interface ExecuteFlowDefinitionQueryParams extends BaseExecuteFlowQueryParams {
  flowDefinitionId: string;
}

export interface ExecuteFlowResponse {
  id: string | null;
}

export interface SignalFlowBody {
  workflowId: string;
  signalName: string;
  payload?: unknown;
}

// FROM @temporalio/client
interface IWorkflowExecution {
  /** WorkflowExecution workflowId */
  workflowId?: string | null;

  /** WorkflowExecution runId */
  runId?: string | null;
}

export type SearchAttributes = Record<
  string,
  SearchAttributeValue | Readonly<SearchAttributeValue> | undefined
>;
export type SearchAttributeValue = string[] | number[] | boolean[] | Date[];

export interface WorkflowExecutionDescription {
  type: string;
  workflowId: string;
  runId: string;
  taskQueue: string;
  status: {
    code: number;
    name: string;
  };
  historyLength: number;
  /**
￼   * Size of Workflow history in bytes.
￼   *
￼   * This value is only available in server versions >= 1.20
￼   */
  historySize?: number;
  startTime: Date;
  executionTime?: Date;
  closeTime?: Date;
  memo?: Record<string, unknown>;
  searchAttributes: SearchAttributes;
  parentExecution?: Required<IWorkflowExecution>;
}

export enum FlowReRunVersionTarget {
  Original = 'Original',
  Published = 'Published',
  Latest = 'Latest',
}

export enum FlowVersionTarget {
  /**
   * Run the latest Published version
   */
  Published = 'Published',

  /**
   * Pin to a specific version of a flow, irrespective of the state of that version, now or ever, as long as its pinned.
   *
   * **Note**: You can NOT Publish a flow that includes a sub-flow pinned to a non-published version
   * (i.e. all pinned sub-flows must also be published)
   */
  SpecificVersion = 'SpecificVersion',
}

export type CancelBulkResolution = 'Canceled' | 'NotFound' | 'Failed';

export interface CancelBulkResult {
  flowRunId: string;
  resolution: CancelBulkResolution;
}

export interface CancelBulkResponse {
  results: CancelBulkResult[];
}
